/* eslint
    no-async-promise-executor: "warn",
    @typescript-eslint/no-shadow: "warn",
    no-underscore-dangle: "off",
    no-restricted-syntax: ["warn", "ForOfStatement"],
    no-unsafe-optional-chaining: "warn",
    no-plusplus: "warn"
*/

import { EasyfyEventData, IDataMapper, IEasyfyEvent, IEasyfyEventExporter, IStatsEventData } from '@shared/easyfy.events/easyfy.eventdata';
import { EventNames, LocalStorageKeys } from '../easyfy.eventhandler';

/* Stats Exporter class */
export class StatsEventExporter implements IEasyfyEventExporter {
  private _eventData: IStatsEventData;

  private _blob: Blob;

  private readonly _payloadKbThreshold: number = 50;

  private readonly _eventThreshold: number = 3;

  private _eventThresholdRemoved: boolean = false;

  mapper: IDataMapper;

  async WithMapper(mapper: IDataMapper): Promise<void> {
    this.mapper = mapper;
    await this.LoadAndSetTransitionStatus();
    document.addEventListener("visibilitychange", this.CheckVisibility.bind(this));
  }

  public RegisterEvent(event: IEasyfyEvent): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (this.mapper) {
        if (!EasyfyEventData.StatsApiIsBlocked()) {
          const eventData = this.mapper.MapEventData(event);
          if (eventData) {
            if (Array.isArray(eventData)) {
              eventData.forEach(async (event) => {
                await this.AccumulateEvent(event);
              });
            }
            else {
              await this.AccumulateEvent(eventData);
            }
          }
        }
      }
      resolve();
    });
  }

  private async LoadAndSetTransitionStatus(): Promise<void> {
    const eventThresholdRemoved = localStorage.getItem(LocalStorageKeys.StatsEventsThresholdRemoved);
    if (eventThresholdRemoved === "true") {
      this._eventThresholdRemoved = true;
      return;
    }

    const storedDataString = localStorage.getItem(LocalStorageKeys.StatsEventsTransitionObj);
    if (storedDataString) {

      try {
        this._eventData = JSON.parse(storedDataString) as IStatsEventData;
      } catch (error) {
        this._eventData = {
          ClientMetaData: null,
          EventRequests: []
        };
      }
    }
  }

  private async RecheckAndSetTransitionStatus(): Promise<void> {

    let eventsMatch = 0;
    const skipEventNames = [EventNames.BannerImpression, EventNames.ElementImpression, EventNames.ProductImpression];

    for (const event of this._eventData?.EventRequests) {
      if (skipEventNames.includes(event?.Event?.type?.toLowerCase()) === false) {
        eventsMatch++;
      }
    }

    if (eventsMatch >= this._eventThreshold) {
      localStorage.setItem(LocalStorageKeys.StatsEventsThresholdRemoved, "true");
      this._eventThresholdRemoved = true;
      localStorage.removeItem(LocalStorageKeys.StatsEventsTransitionObj);
    }
    else {
      localStorage.setItem(LocalStorageKeys.StatsEventsTransitionObj, JSON.stringify(this._eventData));
    }
  }

  private async AccumulateEvent(event: any): Promise<void> {
    return new Promise<void>(async (resolve) => {
      if (!this._eventData || !this._eventData?.ClientMetaData || !this._eventData?.EventRequests) {
        this._eventData = {
          ClientMetaData: EasyfyEventData.GetClientEventMetaData(),
          EventRequests: []
        };
      }

      this._eventData.EventRequests.push({ "Event": event });

      const str = JSON.stringify(this._eventData);
      const bytes = new TextEncoder().encode(str);
      const blob = new Blob([bytes], {
        type: "application/json;charset=utf-8"
      });

      this._blob = blob;

      if (this._eventThresholdRemoved) {
        const payloadSize = await this.GetObjectSizeInKB(this._eventData);
        if (payloadSize > this._payloadKbThreshold) {
          await this.SendEventsToStatsApi();
        }
      }
      else {
        await this.RecheckAndSetTransitionStatus();
      }

      resolve();
    });
  }

  private async SendEventsToStatsApi(): Promise<void> {
    if (this._eventData?.ClientMetaData && this._eventData?.EventRequests?.length > 0 && this._blob) {
      navigator.sendBeacon("/api/stats/events", this._blob);
      this._eventData = null;
      this._blob = null;
    }
  }

  private async CheckVisibility() {
    if (document.visibilityState === "hidden" && this._eventThresholdRemoved) {
      await this.SendEventsToStatsApi();
    }
  }

  async GetObjectSizeInKB(obj: any): Promise<number> {

    const jsonString = JSON.stringify(obj);
    const bytes = new TextEncoder().encode(jsonString).length;
    const kilobytes = bytes / 1024;

    return kilobytes;
  }
}
